import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { history } from '../../../_services/essentials/helpers';
import { authActions, alertActions } from '../../../_services/essentials/store';
import FormControl from "@mui/material/FormControl";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, Grid, TextField, Box, Stack, Typography, Paper, InputAdornment } from "@mui/material";

export { UpdatePassword };

function UpdatePassword() {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    const [showPasswordC, setShowPasswordC] = useState(false);

    const handleTogglePasswordC = () => {
        setShowPasswordC(!showPasswordC);
    };
    const [searchParams] = useSearchParams();
    const token = searchParams ? searchParams.get('token') : '';
    // form validation rules
    const validationSchema = Yup.object().shape({
        newPassword: Yup.string().trim().required("New password is required")
            .min(6, 'Password must be at least 6 characters')
            .max(50, 'Password cannot exceed 50 characters'),
        confirmNewPassword: Yup.string().trim().required("Confirm New password is required")
            .oneOf([Yup.ref('newPassword')], 'Password and Confirm Password must match')
    });

    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors } = formState;

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param

            // if(data.newPassword!==data.confirmNewPassword){
            //     dispatch(alertActions.error('New Password and Confirm New Password are not matching'));
            // } else {

            let message = await dispatch(authActions.updatePassword(data)).unwrap();
            if (message) {
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
                history.navigate('/account/login');
            }
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (

        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: { md: 'flex-end' } }}>
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    maxWidth: '380px',
                    p: { xs: 2, md: 2 },
                    borderRadius: 4,
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '580px',
                    alignContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Stack spacing={0} padding={0}>
                    <Stack>
                        <Typography variant="h5" component="h3" sx={{ fontWeight: 700, color: '#1a1068', mb: 0.5 }}>
                            Reset Password
                        </Typography>
                    </Stack>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Stack
                            sx={{
                                // minWidth: '900px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                px: 2
                            }}
                        >

                            <Box sx={{
                                justifyContent: 'space-between', width: '100%', maxWidth: '350px', mt: 2
                            }}

                            >
                                <FormControl>
                                    <TextField name="token" hidden type="hidden" {...register('token')} value={token} />
                                </FormControl>
                                <FormControl fullWidth>
                                    {/* <FormLabel htmlFor="email">Email</FormLabel> */}
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>New Password
                                    </Typography>
                                    <TextField
                                        name="newPassword"
                                        placeholder="••••••"
                                        // type="password"
                                        type={showPassword ? 'text' : 'password'}

                                        id="newPassword"
                                        autoComplete="off"
                                        autoFocus
                                        fullWidth
                                        variant="outlined"
                                        {...register('newPassword', { required: true })}
                                        InputProps={{
                                            maxLength: 50,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            height: '24px'
                                                        }}
                                                        onClick={handleTogglePassword}
                                                    >
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={Boolean(errors.newPassword)}
                                        helperText={errors.newPassword ? errors.newPassword.message : ""}
                                        sx={{ mb: 2 }}
                                    />
                                </FormControl>
                                <FormControl fullWidth>

                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Confirm New Password
                                    </Typography>
                                    <TextField
                                        name="confirmNewPassword"
                                        placeholder="••••••"
                                        // type="password"
                                        type={showPasswordC ? 'text' : 'password'}

                                        id="confirmNewPassword"
                                        autoComplete="off"
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{
                                            maxLength: 50,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            height: '24px'
                                                        }}
                                                        onClick={handleTogglePasswordC}
                                                    >
                                                        {showPasswordC ? <Visibility /> : <VisibilityOff />}
                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                        {...register('confirmNewPassword', { required: true })}
                                        error={Boolean(errors.confirmNewPassword)}
                                        helperText={errors.confirmNewPassword ? errors.confirmNewPassword.message : ""}
                                        sx={{
                                            mb: 2, borderRadius: '12px', maxWidth: '350px',
                                            width: '100%'
                                        }}
                                    />

                                </FormControl>
                                <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', }} >
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            borderRadius: '16px', width: '50%', textTransform: 'uppercase',
                                            fontWeight: '500', fontSize: '16px', mb: 2, flexGrow: 1
                                        }}
                                    >
                                        Set Password
                                    </Button>

                                    <Button onClick={() => history.navigate("/account/login")} variant="outlined"
                                        color="primary" size="small" sx={{
                                            borderRadius: '16px', width: '50%', textTransform: 'uppercase',
                                            fontWeight: '500', fontSize: '16px', mb: 2, flexGrow: 1
                                        }} >
                                        Cancel
                                    </Button>
                                </Stack>
                            </Box>
                        </Stack>
                    </form>
                </Stack>
            </Paper>
        </Grid>
    );
}
